import { render } from "./AddClientModal.vue?vue&type=template&id=42a9519e&ts=true"
import script from "./AddClientModal.vue?vue&type=script&lang=ts"
export * from "./AddClientModal.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/homebrew/var/www/pickaso/pickaso-reporting-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__